export default {
  buttons: {
    reschedule: 'Reschedule',
    'reschedule-change-address': 'Reschedule/Change address',
    'add-time': 'Add time',
  },
  'pickup-time-min-title': 'Pickup Time min',
  'pickup-time-max-title': 'Pickup Time max',
  'pickup-date': 'Pick a delivery date',
  'change-address': {
    title: 'You have changed your address',
    description: 'Please allow us some time to process your order, and we will provide you with the tracking link.',
    error: 'Sorry, wo do not delivery to theselected address, Please enter another address',
    'outside-service-area': '{facility} does not deliver to this address because it is outside its service area. Please enter another address or contact {facility} for assistance.',
    'check-unavailable': 'We could not check delivery availability. Please check the address and try again, or contact your delivery provider.',
    'retry-check': 'Try again',
  },
  'coolbox-modal': {
    message: 'Your medication has a time-sensitive delivery restriction.<br>Are you sure you want to reschedule the delivery date?',
    rescheduleButton: 'Yes, reschedule',
    cancelButton: 'Cancel',
  },
  'next-day-window': 'Next Day 8:00am-9:00pm',
}
